module.exports = __webpack_public_path__ + "static/media/s2.622af20c.svg";